import BaseService from '@/shared/services/core/base.service';
import { SERVICE_NAMES } from '@/shared/services/core/service-names';

class HomeService extends BaseService {
  async getHome() {
    const response = await this.repository.getHome();
    return this.handleResponse(response);
  }

  async getRelatedContents() {
    const response = await this.repository.getRelatedContents();
    return this.handleResponse(response);
  }

  async getSelfCareTips({ page, pageSize, keyword, categoryMainUniques } = {}) {
    const response = await this.repository.getSelfCareTips({
      page,
      pageSize,
      keyword,
      categoryMainUniques,
    });
    return this.handleResponse(response);
  }

  async getSelfCareTip(mainUnique) {
    const response = await this.repository.getSelfCareTip(mainUnique);
    return this.handleResponse(response);
  }

  async getDryWeightUpdate() {
    const response = await this.repository.getDryWeightUpdate();
    return this.handleResponse(response);
  }

  async closeDryWeightUpdate(itemUnique) {
    const response = await this.repository.closeDryWeightUpdate(itemUnique);
    return this.handleResponse(response);
  }

  async getMicroEducationPrompt() {
    const response = await this.repository.getMicroEducationPrompt();
    return this.handleResponse(response);
  }

  async answerMicroEducationPrompt(mainUnique, ctaItemUnique) {
    const response = await this.repository.answerMicroEducationPrompt(mainUnique, {
      ctaItemUnique,
    });
    return this.handleResponse(response);
  }

  async getEmotionCheckinChoices() {
    const response = await this.repository.getEmotionCheckinChoices();
    return this.handleResponse(response);
  }

  async getEmotionHistory() {
    const response = await this.repository.getEmotionHistory();
    return this.handleResponse(response);
  }

  async getEmotionHistoryEntry(itemUnique) {
    const response = await this.repository.getEmotionHistoryEntry(itemUnique);
    return this.handleResponse(response);
  }

  async submitEmotionCheckin(payload) {
    const response = await this.repository.submitEmotionCheckin(payload);
    return this.handleResponse(response);
  }
}

export default new HomeService(SERVICE_NAMES.HOME);
